module.exports = __webpack_public_path__ + "star.gif?dc4f866c1fcdcd5967ea088876f5f50b";